import { useContext } from "react";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { scheduleCrud } from "@/api/schedule";
import { Button } from "@/components/common/Button";
import { useDepartmentRoute } from "@/hooks/common/use-department-route";
import { showToast } from "@/providers";
import { useUserStore } from "@/stores/use-user-store";
import { canStartSchedule } from "@/utils/features/schedule/permission";
import { getUserRoleByDepartment, isProducerUnavailableInDepartment } from "@/utils/user-positions";

import { ScheduleActionsContext } from "../Provider";

export const ScheduleActionsStart = () => {
  const { schedule } = useContext(ScheduleActionsContext);
  const { department } = useDepartmentRoute();
  const activeUser = useUserStore((state) => state.activeUser);
  const queryClient = useQueryClient();
  const activeRole = getUserRoleByDepartment(activeUser, department);

  const mutation = useMutation({
    mutationFn: () => scheduleCrud.start(schedule.id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["schedule"], refetchType: "all" });
      showToast({ type: "success", title: "Atendimento iniciado!" });
    },
    onError: () =>
      showToast({
        type: "error",
        title: "Erro ao iniciar atendimento.",
        content: "Tente novamente em alguns instantes.",
      }),
  });

  if (
    isProducerUnavailableInDepartment(activeUser, department) ||
    !canStartSchedule(activeRole, activeUser?.id, schedule)
  ) {
    return null;
  }

  return (
    <Button variant="primary" onClick={() => mutation.mutate()} isLoading={mutation.isPending} full>
      Iniciar atendimento
    </Button>
  );
};
